<template>
  <div class="sidebar-left">
    <div class="sidebar">
      <div class="sidebar-content menu-cadastro-client">
        <b-list-group
          class="list-group-messages"
          style="border-radius: 0 !important"
        >
          <div
            v-for="menu in tipoGrupos"
            :key="menu.value + $route.path"
          >
          <b-list-group-item
            v-b-toggle="`${menu.value}collapse`"
            :active="menuAtivo === menu.value"
            @click="selecionar(menu)"
          >
            <font-awesome-icon
              v-if="menu.icon"
              :icon="menu.icon"
              class="mr-75"
            />
            <span class="menu-text">{{ menu.text }}</span>
          </b-list-group-item>
          </div>
        </b-list-group>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.menu-cadastro-client div .sidebar-menu-list .list-group .active {
    background-color: var(--primary);
}
.menu-cadastro-client div .sidebar-menu-list .list-group  {
    .list-group-item:not(.active):not(.disabled) span {
        color: var(--primary) !important;
    }
    .list-group-item:not(.active) .badge {
        color: var(--primary) !important;
    }
}
</style>

<script>
import { BListGroup, BListGroupItem } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'

export default {
  name: 'MenuLateral',
  directives: {
    Ripple,
  },
  components: {
    BListGroup,
    BListGroupItem,
  },
  props: {
    tipoGrupos: {
      type: Array,
      required: true,
    },
  },
  setup(props, context) {
    const menuAtivo = ref({})

    const selecionar = menu => {
      menuAtivo.value = menu.value
      context.emit('selecionado', menu)
    }

    selecionar(props.tipoGrupos[0])

    return {
      menuAtivo,
      selecionar,
    }
  },
}
</script>
